export const hotTopics = [
  { rank: 1, title: "头部主播深夜宣布调整直播节奏", heat: 341.8, trend: "up", categorySlug: "wanghong", articleId: "a2", tag: "直播" },
  { rank: 2, title: "古装剧组夜戏路透双主角同框", heat: 286.4, trend: "up", categorySlug: "yule", articleId: "a1", tag: "路透" },
  { rank: 3, title: "短视频博主道歉视频冲上热搜", heat: 219.7, trend: "down", categorySlug: "wanghong", articleId: "a7", tag: "争议" },
  { rank: 4, title: "悬疑剧大结局解析引爆讨论", heat: 188.9, trend: "up", categorySlug: "yingshi", articleId: "a8", tag: "结局" },
  { rank: 5, title: "两人同逛家居店引恋爱猜测", heat: 176.5, trend: "flat", categorySlug: "qinglv", articleId: "a5", tag: "同框" },
  { rank: 6, title: "颁奖礼红毯造型盘点出炉", heat: 165.7, trend: "down", categorySlug: "yule", articleId: "a11", tag: "红毯" },
  { rank: 7, title: "音乐节临场改歌单幕后花絮", heat: 154.2, trend: "up", categorySlug: "yule", articleId: "a6", tag: "现场" },
  { rank: 8, title: "暴雨夜骑手顺手扶正垃圾桶", heat: 143.1, trend: "up", categorySlug: "shehui", articleId: "a9", tag: "暖心" },
  { rank: 9, title: "慢综艺口碑逆袭的三个细节", heat: 128.3, trend: "down", categorySlug: "yingshi", articleId: "a4", tag: "综艺" },
  { rank: 10, title: "老城区“会唱歌的旧墙”真相", heat: 97.6, trend: "flat", categorySlug: "shehui", articleId: "a3", tag: "奇闻" },
];

export const trendLabels = {
  up: "热度上升",
  down: "热度回落",
  flat: "热度持平",
};